import { render, staticRenderFns } from "./pipe_num.vue?vue&type=template&id=0ba4b316&scoped=true"
import script from "./pipe_num.vue?vue&type=script&lang=js"
export * from "./pipe_num.vue?vue&type=script&lang=js"
import style0 from "./pipe_num.vue?vue&type=style&index=0&id=0ba4b316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba4b316",
  null
  
)

export default component.exports